<template>
  <div>
    <b-form-input
      v-model.trim="value"
      @focus="focused"
      @blur="blured"
      @input="$emit('find-thing', $event)"
      @keydown.down="down"
      @keydown.up="up"
      @keydown.enter.prevent="enter"
      :type="type"
      autocomplete="off"
      :placeholder="`search ${name}s`"
      :required="required"
      :state="state"
    ></b-form-input>
    <b-list-group :style="{ position: listPostition, zIndex: 10}" v-show="list.length > 0 && showList">
      <b-list-group-item
        v-for="(item, i) in list"
        class="search-item"
        :class="{'active': i == listIndex }"
        :key="item.id"
        @click="emitSelectedThing(item); listIndex = i;"
      >{{ item[itemName] }}</b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: "inputList",
  props: {
    list: Array,
    name: String,
    type: String,
    itemName: String,
    required: Boolean,
    state: Boolean,
    listPostition: {
      type: String,
      default: "absolute"
    }
  },
  data() {
    return {
      listIndex: 0,
      value: "",
      showList: true
    };
  },
  methods: {
    up() {
      if (!this.list[0]) {
        return;
      }
      this.listIndex--;
      if (this.listIndex < 0) {
        this.listIndex = this.list.length - 1;
      }

    },
    down() {
      if (!this.list[0]) {
        return;
      }
      this.listIndex++;
      if (this.listIndex >= this.list.length) {
        this.listIndex = 0;
      }
    },
    enter() {
      const item = this.list[this.listIndex];
      if (!item) {
        return;
      }
      this.emitSelectedThing(item);
    },
    emitSelectedThing(thing) {
      this.value = thing[this.itemName];
      this.$emit("select-thing", thing.id);
    }, 
    focused() {
      this.showList = true;
    },
    blured() {
      setTimeout(() => {
        this.showList = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>

.search-item {
  cursor: pointer;
}

.list-group {
  max-height: 20em;
  min-width: 25em;
  overflow-y: auto;
}

</style>